<div class="text-center text-grey-800 text-lg font-bold" data-test-id="title">{{ contentProps.title }}</div>
<div class="text-center text-grey-700 pt-3 pb-5" data-test-id="body" [innerHTML]="contentProps.body"></div>
<div class="flex justify-between">
  <bey-button placeholder="Dismiss" color="dark-blue-outlined" [mat-dialog-close]="true"></bey-button>
  <bey-button placeholder="Reload" color="dark-blue" (click)="process()" data-test-id="reload"></bey-button>
</div>
